import AOS from 'aos'
import {
  FirewallIcon,
  HealthWellbeingIcon,
  NetworkAchitectureIcon,
  PowerBackupIcon,
  RecoverSystemIcon,
  WifiIcon,
} from 'components/Common/Icon'
import { SubText, TitleH2 } from 'components/Common/Typography'
import Image from 'next/image'
import { FC, useEffect, useState } from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'
import ModalVideo from 'react-modal-video'
// import imageWcInfra from '../../../../public/assets/images/wc_team.jpg'

const imageWcInfra = '/assets/images/wc_team.jpg'

const BetterFacility: FC = () => {
  const [isOpen, setOpen] = useState(false)
  useEffect(() => {
    AOS.init()
  }, [])

  return (
    <section className="better_facility ox-hidden">
      <Container>
        <Row className="">
          <Col lg={6} xl={7}>
            <div data-aos="fade-up">
              <TitleH2
                className="text_black mb-3 mb-xl-4 text-center text-sm-start"
                text="Merging Tech-Savvy Facility and Innovative Minds Under One Roof"
              />
            </div>
            <div data-aos="fade-up">
              <SubText
                className="mb-3 mb-lg-4 pt-2 text-center text-sm-start"
                text="The right environment reinforced with top-class infrastructure, ergonomic seating, and a security provisioning allows our innovators to perform and provide results."
              />
            </div>
            <div className="better_facility_left pe-lg-3">
              <div className="better_facility_text d-flex flex-column gap-1 pb-4 pb-lg-0 text-center text-sm-start">
                <div
                  className="banner_fc_link d-flex flex-column flex-md-row gap-lg-2 gap-lg-3 py-2 py-xl-3"
                  // data-aos-duration="700"
                  // data-aos-once="true"
                  // data-aos-delay="100"
                  data-aos="fade-right"
                >
                  <FirewallIcon className="mx-auto m-sm-0" />
                  <span className="fs-xxl-24px fs-xl-22px fs-lg-20px fs-20px fw-600 text_black lh-sm advnc_line advnc_blk">
                    Advanced firewall protection
                  </span>
                </div>
                <div
                  className="banner_fc_link d-flex flex-column flex-md-row gap-lg-2 gap-lg-3 py-2 py-xl-3"
                  data-aos="fade-right"
                  // data-aos-duration="750"
                  // data-aos-once="true"
                  data-aos-delay="100"
                >
                  <RecoverSystemIcon className="mx-auto m-sm-0" />
                  <span className="fs-xxl-24px fs-xl-22px fs-lg-20px fs-20px fw-600 text_black lh-sm advnc_line advnc_blue">
                    Disaster recovery systems
                  </span>
                </div>
                <div
                  className="banner_fc_link d-flex flex-column flex-md-row gap-lg-2 gap-lg-3 py-2 py-xl-3"
                  data-aos="fade-right"
                  // data-aos-duration="800"
                  // data-aos-once="true"
                  data-aos-delay="200"
                >
                  <NetworkAchitectureIcon className="mx-auto m-sm-0" />
                  <span className="fs-xxl-24px fs-xl-22px fs-lg-20px fs-20px fw-600 text_black lh-sm advnc_line advnc_blk">
                    Scalable network architecture
                  </span>
                </div>
                <div
                  className="banner_fc_link d-flex flex-column flex-md-row gap-lg-2 gap-lg-3 py-2 py-xl-3"
                  data-aos="fade-right"
                  // data-aos-duration="850"
                  // data-aos-once="true"
                  data-aos-delay="300"
                >
                  <PowerBackupIcon className="mx-auto m-sm-0" />
                  <span className="fs-xxl-24px fs-xl-22px fs-lg-20px fs-20px fw-600 text_black lh-sm advnc_line advnc_blue">
                    Power backup systems
                  </span>
                </div>
                <div
                  className="banner_fc_link d-flex flex-column flex-md-row gap-lg-2 gap-lg-3 py-2 py-xl-3"
                  data-aos="fade-right"
                  // data-aos-duration="900"
                  // data-aos-once="true"
                  data-aos-delay="400"
                >
                  <HealthWellbeingIcon className="mx-auto m-sm-0" />
                  <span className="fs-xxl-24px fs-xl-22px fs-lg-20px fs-20px fw-600 text_black lh-sm advnc_line advnc_blk">
                    Health &amp; wellbeing facilities
                  </span>
                </div>
                <div
                  className="banner_fc_link d-flex flex-column flex-md-row gap-lg-2 gap-lg-3 py-2 py-xl-3"
                  data-aos="fade-right"
                  // data-aos-duration="950"
                  // data-aos-once="true"
                  data-aos-delay="500"
                >
                  <WifiIcon className="mx-auto m-sm-0" />
                  <span className="fs-xxl-24px fs-xl-22px fs-lg-20px fs-20px fw-600 text_black lh-sm advnc_line advnc_blue">
                    High-Speed wifi
                  </span>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} xl={5} className="better_facility_right">
            <div className="better_facility_inner ms-lg-4 me-lg-5 px-3 px-md-0">
              <div className="right_img" data-aos="zoom-in">
                <div className="play_btn d-flex align-items-center justify-content-center position-absolute">
                  <Button
                    variant="seondary"
                    className="d-flex align-items-center justify-content-center"
                    aria-label="better_facility_play_btn_1"
                    onClick={() => setOpen(true)}
                  >
                    <Image
                      src="/assets/images/play.svg"
                      className=""
                      alt="Play Video"
                      height={38}
                      width={38}
                    />
                  </Button>
                </div>
                <Image
                  src={imageWcInfra}
                  alt="Webclues Facility"
                  className="img-fluid cursor-pointer"
                  width="642"
                  height="803"
                  quality={75}
                  style={{
                    maxWidth: '100%',
                    height: 'auto',
                  }}
                />

                <div className="white_block block_1 text-center">
                  <p className="fs-26px fs-lg-30px fs-xxl-36px text_black fw-800 lh-1 mb-2">
                    20,000
                  </p>
                  <span className="fs-17px fs-lg-18px fs-xl-20px txt_sml">
                    Sq. Ft Workspace
                  </span>
                </div>
                <div className="white_block block_2 text-center">
                  <p className="fs-26px fs-lg-30px fs-xxl-36px text_black fw-800 lh-1 mb-2">
                    24x7
                  </p>
                  <span className="ffs-17px fs-lg-18px fs-xl-20px txt_sml">
                    Support
                  </span>
                </div>
                <div className="white_block block_3 text-center">
                  <span className="fs-17px fs-lg-18px fs-xl-20px lh-sm txt_sml">
                    Serving with the best facilities
                  </span>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      {isOpen && (
        <ModalVideo
          channel="youtube"
          youtube={{
            autoplay: 1,
            mute: 1,
          }}
          isOpen={isOpen}
          videoId="I6tq2LWTW-s"
          onClose={() => setOpen(false)}
        />
      )}
    </section>
  )
}

export default BetterFacility
